<template>
  <div :class="`stats stats--${alignClass}`">
    <figure v-for="item in items" :class="`stat-item stat-item--${toCssName(item.stat_type)}`">
      <header class="stat-item__header">
        <span class="stat-item__number">{{item.number_1}}</span>

        <template v-if="item.stat_type === 'Fraction'">
          <span class="stat-item__symbol">IN</span>
          <span class="stat-item__number">{{item.number_2}}</span>
        </template>

        <template v-if="item.stat_type === 'Percentage'">
          <span class="stat-item__symbol">%</span>
        </template>
      </header>

      <figcaption class="stat-item__contents">
        <div v-if="item.statistic_text" class="stat-item__text" v-html="getHtmlContent(item.statistic_text)"></div>
        <div v-if="item.source" class="stat-item__source" v-html="item.source"></div>
      </figcaption>
    </figure>
  </div>
</template>

<script>
import PrismicDOM from 'prismic-dom'

export default {
  name: 'content-stats',
  props: ['content'],
  computed: {
    items () {
      return this.content.items
    },
    alignClass () {
      return this.content.primary.align ? this.toCssName(this.content.primary.align) : 'none'
    },
    title () {
      return this.content.title ? PrismicDOM.RichText.asHtml(this.content.title) : null
    }
  },
  methods: {
    toCssName (str) {
      return str.replace(/\s+/g, '-').toLowerCase()
    },
    linkResolver (doc) {
      return `#/post/${doc.slug}`
    },
    getTextContent (str) {
      return str ? PrismicDOM.RichText.asText(str) : ''
    },
    getHtmlContent (str) {
      return str ? PrismicDOM.RichText.asHtml(str, this.linkResolver) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.stats {
  border-top: 6px solid #1A1919;
  border-left: 1px solid #1A1919;
  border-right: 1px solid #1A1919;
  border-bottom: 1px solid #1A1919;
  display: inline-block;
  font-family: $font-heading;
  margin-bottom: 1rem;
  margin-left: 20px;
  margin-right: 20px;
  text-align: center;
  padding: 0 1rem 1rem;
  position: relative;
  z-index: z('stat-block');

  &:before {
    width: 0;
    height: 0;
    border-top: 60px solid transparent;
    border-right: 60px solid white;
    content: "";
    position: absolute;
    bottom: -2px;
    right: -1px;
    z-index: z('stat-block-before');
  }

  &:after {
    width: 0;
    height: 0;
    border-top: 60px solid transparent;
    border-right: 60px solid #000;
    content: "";
    position: absolute;
    bottom: -1px;
    right: -1px;
    z-index: z('stat-block-after');
  }

  .leadership & {
    color: $leadership;
  }

  .management & {
    color: $management;
  }

  .legal-tech & {
    color: $legal-tech;
  }

  .legal-market & {
    color: $legal-market;
  }
}

.stats--right,
.stats--left,
.stats--center {
  @media (min-width: $breakpoint-md) {
     // width: 50%;
     // max-width: 500px;
  }
}

.stats--center {
  margin-left: auto;
  margin-right: auto;
}

.stats--right {
  @media (min-width: 768px) {
    float: right;
    margin-right: 20px;
    max-width: 300px;
  }

  @media (min-width: 1024px) {
    margin-right: 20%;
  }
}

.stats--left {
  @media (min-width: 768px) {
    float: left;
    margin-left: 20px;
    max-width: 300px;
  }

  @media (min-width: 1024px) {
    margin-left: 20%;
  }
}

.stat-item {
  box-sizing: border-box;
  margin: 0;
  padding: 2rem;
}

.stat-item + .stat-item {
  border-top: 1px solid #ddd;
}

.stat-item--number {}

.stat-item__header {
  display: flex;
  justify-content: center;
  line-height: 1;

  .stat-item--fraction & {
    align-items: center;
  }

  .stat-item--percent & {
    align-items: flex-start;
  }
}

.stat-item__number {
  font-size: 5rem;
  font-weight: bold;
}

.stat-item__symbol {
  .stat-item--fraction & {
      padding: .5rem;
  }

  .stat-item--percentage & {
      font-size: 2rem;
  }
}

.stat-item__source {
  font-size: 1rem;
  font-style: italic;
}
</style>

<style>
.stat-item__text > p {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// Stats.vue?327b669c